import { render, staticRenderFns } from "./LoadingBar.vue?vue&type=template&id=2ac25922"
var script = {}
import style0 from "./LoadingBar.vue?vue&type=style&index=0&id=2ac25922&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports